module.exports = __webpack_public_path__ + "src/assets/games/57/9.gif";